export default __webpack_public_path__ + "static/0082-2210d9849e10759ec9ec54a1adca52d1.png";